// Services: header fades up, then cards stagger in from below.
document.addEventListener( 'DOMContentLoaded', () => {
	const sections = Array.from( document.querySelectorAll( '.services-block' ) );
	if ( ! sections.length ) return;

	const EASING  = 'cubic-bezier(0.22, 1, 0.36, 1)';
	const DURATION = 0.65;
	const STAGGER  = 0.10;
	const OFFSET   = '32px';

	sections.forEach( ( section ) => {
		const header = section.querySelector( '.services-header' );
		const cards  = Array.from( section.querySelectorAll( '.service-item-card' ) );

		if ( header ) {
			header.style.opacity    = '0';
			header.style.transform  = `translateY( ${ OFFSET } )`;
			header.style.transition = `opacity ${ DURATION }s ${ EASING }, transform ${ DURATION }s ${ EASING }`;
		}

		cards.forEach( ( card, i ) => {
			card.style.opacity    = '0';
			card.style.transform  = `translateY( ${ OFFSET } )`;
			card.style.transition = `opacity ${ DURATION }s ${ EASING } ${ ( i * STAGGER ) + 0.2 }s, transform ${ DURATION }s ${ EASING } ${ ( i * STAGGER ) + 0.2 }s`;
		} );

		if ( header ) {
			const headerObserver = new IntersectionObserver(
				( entries, obs ) => {
					entries.forEach( ( entry ) => {
						if ( entry.isIntersecting ) {
							header.style.opacity   = '1';
							header.style.transform = 'translateY(0)';
							obs.unobserve( entry.target );
						}
					} );
				},
				{ threshold: 0.30 }
			);
			headerObserver.observe( header );
		}

		cards.forEach( ( card ) => {
			const cardObserver = new IntersectionObserver(
				( entries, obs ) => {
					entries.forEach( ( entry ) => {
						if ( entry.isIntersecting ) {
							card.style.opacity   = '1';
							card.style.transform = 'translateY(0)';
							obs.unobserve( entry.target );
						}
					} );
				},
				{ threshold: 0.20 }
			);
			cardObserver.observe( card );
		} );
	} );
} );

// Service card button hover effect.
document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.service-btn[data-hover-bg]' ).forEach( ( btn ) => {
		const hoverBg    = btn.dataset.hoverBg;
		const hoverColor = btn.dataset.hoverColor;
		const baseColor  = btn.dataset.baseColor;

		btn.addEventListener( 'mouseenter', () => {
			btn.style.backgroundColor = hoverBg;
			btn.style.borderColor     = hoverBg;
			btn.style.color           = hoverColor;
		} );
		btn.addEventListener( 'mouseleave', () => {
			btn.style.backgroundColor = 'transparent';
			btn.style.borderColor     = baseColor;
			btn.style.color           = baseColor;
		} );
	} );
} );